import { useRouter } from 'next/router'
import { SlugPathItem } from 'types/slugPath'

export const useProductDetailBack = (
  paths: SlugPathItem[],
  productId?: string
): (() => void) => {
  const router = useRouter()

  return () => {
    const lastItem = paths?.[paths.length - 1]
    let isFromInternalDomain = false
    let isNotHomePage = false

    try {
      isNotHomePage = window.location.pathname !== '/'

      isFromInternalDomain = localStorage.getItem('intProductId') == productId
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Error checking navigation:', error)
    }

    if (isFromInternalDomain && isNotHomePage) {
      router.back()
    } else if (lastItem) {
      router.push(lastItem.url)
    }
  }
}
